import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseProgress',
  props: {
    numberOfLessonsCompleted: {
      type: Number,
      required: true,
    },
    numberOfLessons: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  const { translateString } = useI18n()

  

  const progressPercentage = computed(() => {
    if (!props.numberOfLessons) return 0
    return Math.min(100, Math.round((props.numberOfLessonsCompleted / props.numberOfLessons) * 100))
  })

  const progressText = computed(() => {
    if (props.numberOfLessonsCompleted === 0) return `0/${props.numberOfLessons} ${translateString('courses.lessons')}`
    return `${props.numberOfLessonsCompleted}/${props.numberOfLessons} ${translateString('courses.lessons')}`
  })

return { __sfc: true,translateString, props, progressPercentage, progressText, computed, useI18n }
}

})